module.exports = __webpack_public_path__ + "img/music-note-slash.ea6ddd01.svg";